<template>

  <div>
    <div class="questionnaire-body"/>
    <router-link :to="{ name: 'mes-tests'}" class="questionnaire-navbar">
      <img alt="" src="@/assets/img/previous.png">
      <span>Annuler</span>
    </router-link>


    <CommencerIntroduction v-if="type==='introduction'" @debuter="debuter"/>
    <CommencerExpression v-if="type==='expression'" @debuter="debuter"/>
    <CommencerRaisonnement v-if="type==='raisonnement'" @debuter="debuter"/>
    <CommencerCalcul v-if="type==='calcul'" @debuter="debuter"/>
    <CommencerArgumentation v-if="type==='argumentation'" @debuter="debuter"/>
  </div>
</template>

<script setup>
import {computed, provide, ref} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import CommencerIntroduction from '@/components/Questionnaire/Commencer/Introduction.vue'
import CommencerExpression from '@/components/Questionnaire/Commencer/Expression.vue'
import CommencerRaisonnement from '@/components/Questionnaire/Commencer/Raisonnement.vue'
import CommencerCalcul from '@/components/Questionnaire/Commencer/Calcul.vue'
import CommencerArgumentation from '@/components/Questionnaire/Commencer/Argumentation.vue'

import UserService from "@/services/user.service"
import RouteEnum from "@/router/RouteEnum";

const route = useRoute()
const router = useRouter()

const type = ref(route.params.type)
const loading = ref(false)

const isDisabled = computed(() => loading.value)

const debuter = (domainId) => {
  if (loading.value) return
  loading.value = true

  UserService.debutQuestionnaire(domainId).then(
      (response) => {
        router.push({
          name: RouteEnum.TEST_QUESTION,
          params: {type: route.params.type}
        })
        return response
      },
      (error) => {
        return error
      }
  )
}

provide('isDisabled', isDisabled)
provide('debuter', debuter)
</script>
